import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.997 12.997L4.72385 12.997C4.65785 12.9973 4.59244 12.9845 4.53141 12.9594C4.47037 12.9342 4.41492 12.8973 4.36825 12.8506C4.32157 12.8039 4.28461 12.7485 4.25947 12.6874C4.23434 12.6264 4.22154 12.561 4.22181 12.495L4.22181 11.505C4.22154 11.439 4.23434 11.3736 4.25947 11.3126C4.28461 11.2516 4.32158 11.1961 4.36825 11.1494C4.41492 11.1028 4.47037 11.0658 4.53141 11.0407C4.59244 11.0155 4.65785 11.0027 4.72385 11.003L14.991 11.003L19.2761 11.003C19.3421 11.0027 19.4075 11.0155 19.4686 11.0407C19.5296 11.0658 19.585 11.1028 19.6317 11.1494C19.6784 11.1961 19.7154 11.2516 19.7405 11.3126C19.7656 11.3736 19.7784 11.439 19.7782 11.505V12.495C19.7784 12.561 19.7656 12.6264 19.7405 12.6874C19.7154 12.7485 19.6784 12.8039 19.6317 12.8506C19.585 12.8973 19.5296 12.9342 19.4686 12.9594C19.4075 12.9845 19.3421 12.9973 19.2761 12.997L12.997 12.997Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgMinusOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgMinusOutline;
